import { isURL } from "validator";

// Convierte una URL de track de Spotify a su URL de embed.
// Acepta cualquier variante de idioma (intl-es, intl-pt, …), con o sin
// query string. Devuelve undefined si el link no es un track de Spotify
// (el caller decide cómo mostrar el estado deshabilitado).
const spotifyToEmbed = (url) => {
  if (typeof url !== "string" || !isURL(url)) {
    return;
  }

  const match = url.match(
    /^https?:\/\/open\.spotify\.com\/(?:intl-[a-z]{2}(?:-[a-z]{2})?\/)?track\/([a-zA-Z0-9]+)/i
  );
  if (match && match[1]) {
    return "https://open.spotify.com/embed/track/" + match[1];
  }
};

export default spotifyToEmbed;
